import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import MerchantSwitcher from "./MerchantSwitcher";
import UserMenu from "./UserMenu";
import "../../Styles/components/navbar.scss";
import { useNavigate } from "react-router-dom";

export default function Navbar({
  sidebarOpen,
  setSidebarOpen,
  session,
}) {
  const navigate = useNavigate();
  return (
    <header className="new-app__topbar navbar-shell">
      <div className="navbar-shell__start">
        {!sidebarOpen ? (
          <button
            type="button"
            className="new-app__menu-button"
            aria-label="Open navigation"
            aria-expanded={sidebarOpen}
            onClick={() => setSidebarOpen(true)}
          >
            <FontAwesomeIcon icon={faBars} />
          </button>
        ) : null}
        <MerchantSwitcher session={session} />
      </div>

      <div className="navbar-shell__end">
        <UserMenu session={session} />
      </div>
      <div className="navbar-shell__end">
        <button className="navbar_transaction_button" onClick={() => navigate("/suyooltosuyool")}> + New Transaction </button>
      </div>
    </header>
  );
}
